import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fuelSurchargeTypesAdapter = getAdapter({ idFieldName: 'value' });

const fuelSurchargeTypesSlice = createSlice({
  name: 'fuelSurchargeTypes',
  initialState: fuelSurchargeTypesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setFuelSurchargeTypes: (state, { payload: { fuelSurchargeTypes, source } }) => {
      fuelSurchargeTypesAdapter.setAll(state, fuelSurchargeTypes);
      state.source = source;
    }
  }
});

const selectors = fuelSurchargeTypesAdapter.getSelectors(({ fuelSurchargeTypes }) => fuelSurchargeTypes);

export const getFuelSurchargeTypes = state => selectors.selectAll(state);

export const { setFuelSurchargeTypes } = fuelSurchargeTypesSlice.actions;

export default fuelSurchargeTypesSlice.reducer;
